import {useQuery} from '@apollo/client';
import {GetCuroCodes} from '../../../schema-types/GetCuroCodes';
import {GET_PRIORITIES, GET_STATUS_AT_REVIEW} from '../goalsQueries';

const useStatusPriority = () => {
  const {
    loading: statusLoading,
    data: statusData,
    error: statusError,
  } = useQuery<GetCuroCodes>(GET_STATUS_AT_REVIEW);

  const {
    loading: priorityLoading,
    data: priorityData,
    error: priorityError,
  } = useQuery<GetCuroCodes>(GET_PRIORITIES);

  return {
    statusData: statusData?.getCuroCodes || [],
    priorityData: priorityData?.getCuroCodes || [],
    statusLoading,
    statusError,
    priorityLoading,
    priorityError,
  };
};

export default useStatusPriority;
